<div class="mainContent">
  <div class="pageHeader" i18n>Settings</div>

  <div class="itemsRow">   
    <mat-card class="itemCard">
      <mat-card-header class="itemContent">   
        <mat-icon>map</mat-icon>
        <mat-card-title class="itemHeader" i18n>Map</mat-card-title>            
      </mat-card-header>
      <mat-card-content>
        <mat-card-subtitle class="itemDescription" i18n>Define map attributes</mat-card-subtitle>  
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-footer class="itemAction" (click)="setMapSettings()" i18n>SET</mat-card-footer>
    </mat-card> 

    <mat-card class="itemCard">
      <mat-card-header class="itemContent">   
        <mat-icon>email</mat-icon>
        <mat-card-title class="itemHeader">Email</mat-card-title>            
      </mat-card-header>
      <mat-card-content>
        <mat-card-subtitle class="itemDescription" i18n>Define email preferences</mat-card-subtitle>  
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-footer class="itemAction" (click)="setEmailSettings()" i18n>SET</mat-card-footer>
    </mat-card>   

    <mat-card class="itemCard">
      <mat-card-header class="itemContent">   
        <mat-icon>translate</mat-icon>
        <mat-card-title class="itemHeader" i18n>Language</mat-card-title>            
      </mat-card-header>
      <mat-card-content>
        <mat-card-subtitle class="itemDescription" i18n>Set the preferred language</mat-card-subtitle>  
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-footer class="itemAction" (click)="setLanguageSettings()" i18n>SET</mat-card-footer>
    </mat-card> 
  </div>

  <div class="itemsRow separation">
    <mat-card class="itemCard">
      <mat-card-header class="itemContent">   
        <mat-icon>download</mat-icon>
        <mat-card-title class="itemHeader" i18n>Import</mat-card-title>            
      </mat-card-header>
      <mat-card-content>
        <mat-card-subtitle class="itemDescription" i18n>Import file</mat-card-subtitle>  
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-footer class="itemAction" (click)="onImport()" i18n>IMPORT</mat-card-footer>
    </mat-card> 

    <mat-card class="itemCard">
      <mat-card-header class="itemContent">   
        <mat-icon>publish</mat-icon>
        <mat-card-title class="itemHeader" i18n>Export</mat-card-title>            
      </mat-card-header>
      <mat-card-content>
        <mat-card-subtitle class="itemDescription" i18n>Export settings</mat-card-subtitle>  
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-footer class="itemAction">
        <a [href]="fileUrl" download="settings.json" (click)="onExport()" class="exportText" i18n>EXPORT</a>
      </mat-card-footer>
    </mat-card>
  </div>  
</div>
